import React from 'react'
import axios from 'axios';
import { Link } from "react-router-dom"
import { connect } from 'react-redux';
import Alert from '~/Common-Objects/UI/Alert'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import DbConn from '~/Classes/siteVars.js'
import i18n from '~/i18n'
import LeftPanel from './loginAttractMode.jsx';
import { Translation } from 'react-i18next';
import LandingPageTemplate from './template.jsx';
import EmailValidator from '~/Classes/emailValidator.jsx';

@connect((store) => {
	return {
		siteMaster: store.siteMaster
	}
})
export default class ReminderTemplate extends React.Component {
	constructor(props, context) {
		super(props);
		this.state = { emailAddress: '', masterErrorMsg: '', complete: false, loading: false };
		this.handleChange = this.handleChange.bind(this);
		this.sendReminder = this.sendReminder.bind(this);
		this.redirectToPage = this.redirectToPage.bind(this);
	}

	redirectToPage(pageURL) {
		this.props.history.push('/' + pageURL);
	}

	handleChange(event) {
		this.setState({
			[event.currentTarget.name]: event.currentTarget.value
		});
	}

	sendReminder() {
		const isValid = EmailValidator.validateEmail(this.state.emailAddress)
		if (!isValid) {
			return this.setState({ masterErrorMsg: i18n.t('login:reminder.invalidEmail') })
		}
		var baseUrl = DbConn.getConnString()
		this.setState({ loading: true, masterErrorMsg: '' });
		axios.post(baseUrl + '/forgotpassword', {
			emailAddress: this.state.emailAddress,
			siteMasterId: this.props.siteMaster.siteId
		}).then(() => {
			this.setState({ complete: true, loading: false });
		}).catch(error => {
			this.setState({ masterErrorMsg: error.response.data.error, loading: false })
		})
	}

	render() {
		return (<Translation ns="translations">
			{
				(t, { i18n }) => {
					return (
						<LandingPageTemplate
							paperClasses="landing-login"
							header={t('login:reminder.forgot')}
							subheader={t('login:reminder.forgotSub')}
						>
							<TextInput
								outerClassName="mar-b32"
								type="email"
								name="emailAddress"
								label={t("login:login.email")}
								value={this.state.emailAddress}
								onChange={this.handleChange}
								error={this.state.masterErrorMsg}
							/>

							{this.state.complete && <Alert
								type="success"
								header={t('login:reminder.successHeader')}
								content={t('login:reminder.successContent')}
								className={"mar-b32"}
							/>}

							<Button
								className="button-primary button-fullwidth"
								style={{ marginBottom: 16 }}
								disabled={this.state.loading}
								iconRight={<Icons icon="arrowRight" />}
								text={t('login:reminder.reset')}
								onClick={this.sendReminder}
							/>

							<div style={{ textAlign: 'center' }}><Link to="/">{t("login:reminder.back")}</Link></div>
						</LandingPageTemplate>
					)
					return (<div className="login-holder">

						{(this.props.siteMaster.siteName === "MPZMail" || this.props.siteMaster.siteName === "Transpond") &&
							<LeftPanel history={this.props.history} />
						}

						<div className="login-right-panel">
							<div className="login-right-panel-login">
								<Paper className="login-right-panel-login_loginBox">



									<h3 className="mar-b5">
										{t('login:reminder.header')} <span>{this.props.siteMaster.siteName}</span> {t('login:reminder.header2')}
									</h3>
									<div className="paper_subheading mar-b40">
										{t('login:reminder.subHeader')}
									</div>

									<TextInput
										label={t('login:login.emailPlaceholder')}
										labelOptions={<a onClick={() => { this.redirectToPage('') }}>{t('login:reminder.remembered')}</a>}
										type="email"
										name="emailAddress"
										onChange={this.handleChange} onKeyPress={this.handleChange}
										outerClassName="mar-b24"
										error={this.state.masterErrorMsg}
										maxLength="255"
									/>

									<Button className="button-primary" text={t('login:reminder.button')} onClick={this.sendReminder} />

								</Paper>
							</div>
						</div>
					</div>)
				}
			}
		</Translation>)


	}
};